// Generated by CoffeeScript 1.12.7
var concatRight, isLocalFile, normalize, prependNodeModules;

normalize = require('path').normalize;

prependNodeModules = function(v) {
  return ['node_modules', v];
};

concatRight = function(a1, a2) {
  return a2.concat(a1);
};

isLocalFile = function(path) {
  return path[0] === '.';
};

module.exports = function(base, path, callers) {
  var end, out;
  if (callers.length === 0 && isLocalFile(path)) {
    out = path;
  } else {
    end = isLocalFile(path) ? path : prependNodeModules(path);
    out = callers.map(prependNodeModules).reduceRight(concatRight, end).join('/');
  }
  return normalize([base, out].join('/'));
};
